import Vue from "vue"

const path = "seatgeek"

export default {
    generateFromScrape(data) {
        return Vue.prototype.$http.post(`${path}/scrape-generate`, { data })
    }
}
